import { render, staticRenderFns } from "./addGfBasicMsg.vue?vue&type=template&id=2ed362a8&scoped=true"
import script from "./addGfBasicMsg.vue?vue&type=script&lang=js"
export * from "./addGfBasicMsg.vue?vue&type=script&lang=js"
import style0 from "./addGfBasicMsg.vue?vue&type=style&index=0&id=2ed362a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed362a8",
  null
  
)

export default component.exports